<template>
  <a @click="triggerAction">
    <MIcon name="check" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $tc('compare') }}
    </span>
    <FlotoDrawer :open="showDrawer" width="60%" @hide="showDrawer = false">
      <template v-slot:title>
        {{ $t('compare') }} {{ $tc('baseline') }}
      </template>
      <div class="inline-flex justify-end mb-2">
        <ExportButton
          :button-text="$t('print')"
          class="mr-2"
          :header="`${$t('print')}`"
          :options="formatOptions"
          @submit="handleExportBaselineCompare"
        />
      </div>
      <MRow class="flex-1">
        <MCol :size="12" class="left-shadow-only overflow-hidden">
          <MRow class="flex flex-1 h-100">
            <MCol class="flex flex-1 flex-col overflow-hidden">
              <FlotoCrudContainer
                as-table
                :fetch-fn="getCompareBaseline"
                prepend-new-item
                :columns="tableColumns"
              >
                <template v-slot:fieldName="{ item }">
                  <td class="text-ellipsis">
                    {{ item.fieldName }}
                    <!-- {{
                      (
                        availableColumns.find(
                          (c) => c.key === item.fieldName
                        ) || {}
                      ).text
                    }} -->
                  </td>
                </template>
                <template v-slot:baselineOneValue="{ item }">
                  <td class="text-ellipsis">
                    <AttributeFieldElement
                      :class="item.different ? 'text-secondary-red' : ''"
                      disabled
                      :column="
                        availableColumns.find((c) => c.key === item.fieldKey)
                      "
                      :item="prepareItem(item, item.baselineOneValue)"
                    />
                  </td>
                </template>
                <template v-slot:baselineTwoValue="{ item }">
                  <td class="text-ellipsis">
                    <AttributeFieldElement
                      :class="item.different ? 'text-secondary-red' : ''"
                      disabled
                      :column="
                        availableColumns.find((c) => c.key === item.fieldKey)
                      "
                      :item="prepareItem(item, item.baselineTwoValue)"
                    />
                  </td>
                </template>
              </FlotoCrudContainer>
            </MCol>
          </MRow>
        </MCol>
      </MRow>
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import ExportButton from '@modules/reports/components/export-button'
import { getSupportedDataApi } from '@modules/asset-management/api/manage-baseline-api'
import AttributeFieldElement from '@components/baseline-attribute-component/baseline-attribute-field-element'
import { transformRuleValue } from '@data/baseline'
import { compareBaselienApi } from '@modules/asset/asset-api'

export default {
  name: 'Compare',
  components: { ExportButton, AttributeFieldElement },
  props: { selectedItems: { type: Array, required: true } },
  data() {
    this.formatOptions = [
      { text: this.$t('pdf'), value: 'pdf' },
      { text: this.$t('excel'), value: 'excel' },
    ]
    return {
      showDrawer: false,
      baselineOne: this.selectedItems[0],
      baselineTwo: this.selectedItems.slice(1),
      baseline: {},
      availableColumns: [],
    }
  },
  computed: {
    ...authComputed,
    tableColumns() {
      return [
        { name: `${this.$tc('attribute', 2)}`, key: 'fieldName' },
        {
          name: `${this.baseline && this.baseline.baseline1Name}`,
          key: 'baselineOneValue',
        },
        {
          name: `${this.baseline && this.baseline.baseline2Name}`,
          key: 'baselineTwoValue',
        },
      ]
    },
    selectedItemIds() {
      return [this.baselineOne.id, ...this.baselineTwo.map(({ id }) => id)]
    },
  },
  created() {
    this.getSupportData()
  },
  methods: {
    prepareItem(item, value) {
      let itemData = {
        ...(this.availableColumns.find((c) => c.key === item.fieldKey) || {}),
        value: transformRuleValue(value, item.fieldKey),
      }
      return itemData
    },
    getSupportData() {
      getSupportedDataApi().then((data) => {
        this.availableColumns = data.items
      })
    },
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        if (this.selectedItems[0].id > 0 && this.selectedItems[1].id > 0) {
          this.showDrawer = true
        }
      }, 400)
    },
    getCompareBaseline() {
      // const baseline1Id = this.baselineOne.id
      // const baseline2Id = this.baselineTwo.map(({ id }) => id)
      const baseline1Id = this.selectedItems[0].id
      const baseline2Id = this.selectedItems[1].id
      return compareBaselienApi(baseline1Id, baseline2Id).then((data) => {
        this.baseline = data.items[0]
        return data
      })
    },
    handleExportBaselineCompare(data) {
      const baseline1Id = this.selectedItems[0].id
      const baseline2Id = this.selectedItems[1].id
      window.open(
        `/api/analytics/download/compare/baseline/print?baseline1=${baseline1Id}&baseline2=${baseline2Id}&exportFormat=${data.exportFormat}&mid=${this.accessToken}`,
        '__blank'
      )
    },
  },
}
</script>
